import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { QuestionnaireService } from "../services/questionnaire.service";

@Component({
  selector: 'app-process-save-dialog',
  templateUrl: './process-save-dialog.component.html',
  styleUrls: ['./process-save-dialog.component.scss']
})
export class ProcessSaveDialogComponent implements OnInit {
  asmachta$: Observable<string>;

  constructor(
    public activeModal: NgbActiveModal,
    private questionnaireService: QuestionnaireService,
    private router: Router) { }

  ngOnInit(){
      this.asmachta$ = this.questionnaireService.getAsmachta$();
  }

  dismiss() {
    this.activeModal.dismiss();
  }

  exit() {
    this.router.navigate(['']);
    this.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/app/process-save-dialog/process-save-dialog.component.ts